export default __webpack_public_path__ + "static/media/category.32af36fb.svg";